import { color, spacing } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
import { baseInput } from "./_base.js";
import { valid, invalid } from "./_state.js";
const CHEVRON_DOWN_RED = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHZpZXdCb3g9IjAgMCA5NiA5NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00OC43NDAyIDUyLjE3OTRMMjMuNjY3NSAyNEwyIDI0LjAwMDFMMzcuMDkxNSA2NS4yNzE0TDM3LjA3NTMgNjUuMjg5N0w0OC43MTYgNzlMNDguNzQwMiA3OC45NzE1TDQ4Ljc2NDQgNzlMNjAuNDA1MSA2NS4yODk3TDYwLjM4ODkgNjUuMjcxNEw5NS40ODA0IDI0TDczLjgxMjkgMjQuMDAwMUw0OC43NDAyIDUyLjE3OTRaIiBmaWxsPSIjRTIxODMzIi8+Cjwvc3ZnPgo=`;
const classNamePrefix = "umd-field-select";
const select = {
  ...baseInput,
  "&[aria-invalid='true']": {
    ...invalid
  },
  "&[aria-invalid='false']": {
    ...valid
  },
  "&[multiple]": {
    cursor: "pointer",
    resize: "vertical",
    "& option": {
      padding: "5px",
      color: color.black,
      transition: "color 0.3s",
      "&:hover": {
        color: color.red
      },
      "&:checked": {
        backgroundColor: color.gray.light
      }
    }
  }
};
const selectWrapper = objectWithClassName({
  backgroundColor: color.white,
  overflow: "hidden",
  position: "relative",
  className: [
    `${classNamePrefix}-wrapper`,
    /** @deprecated Use 'umd-field-select-wrapper' instead */
    "umd-forms-select-wrapper"
  ],
  "& select": {
    appearance: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
    paddingRight: spacing.lg,
    position: "relative",
    zIndex: 9
  },
  "&:before": {
    content: "''",
    backgroundImage: `url("${CHEVRON_DOWN_RED}")`,
    backgroundPosition: "center center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    display: "block",
    position: "absolute",
    right: spacing.sm,
    top: `calc(50% - ${spacing.min})`,
    zIndex: 0,
    height: spacing.sm,
    width: spacing.sm
  }
});
export {
  select,
  selectWrapper
};
//# sourceMappingURL=select.js.map
